const GCS_TUTOR_PROFILE_ORIGIN = 'https://storage.googleapis.com'
const GCS_TUTOR_PROFILE_BUCKET = 'podo-tutor-profile'
const ASSET_ENDPOINT = '/api/tutors/profile/asset'

/**
 * 저장값에서 GCS 오브젝트 경로를 추출한다.
 * - 신규: 오브젝트 경로만 저장됨 (`3209/production_profile.webp`)
 * - 레거시: GCS 풀 URL (`https://storage.googleapis.com/podo-tutor-profile/3209/...`)
 * 대상이 아니면 null.
 */
const extractTutorProfileObjectPath = (value: string): string | null => {
  // 레거시 GCS 풀 URL
  if (value.startsWith(`${GCS_TUTOR_PROFILE_ORIGIN}/`)) {
    try {
      const parsed = new URL(value)
      const [bucket, ...objectPathParts] = parsed.pathname.split('/').filter(Boolean)
      if (bucket !== GCS_TUTOR_PROFILE_BUCKET || objectPathParts.length === 0) {
        return null
      }
      return objectPathParts.join('/')
    } catch {
      return null
    }
  }

  // 다른 스킴의 절대 URL 또는 이미 프록시 경로면 대상 아님
  if (/^[a-z][a-z\d+.-]*:\/\//i.test(value) || value.startsWith('/')) {
    return null
  }

  // 오브젝트 경로 형태 (`<tutorId>/<file>`)
  const normalized = value.replace(/^\/+/, '')
  return normalized.length > 0 ? normalized : null
}

/**
 * 비공개 GCS 튜터 프로필 저장값(오브젝트 경로 또는 레거시 URL)을 학생앱 프록시 경로로 변환한다.
 * 프록시는 조회 시 V4 signed URL 로 리다이렉트한다. 대상이 아니면 그대로 반환한다.
 * (tutor-web toTutorProfileMediaUrl 과 동일)
 */
export const toTutorProfileMediaUrl = (url: string | null | undefined) => {
  if (!url) {
    return null
  }

  const objectPath = extractTutorProfileObjectPath(url)
  if (!objectPath) {
    return url
  }

  const params = new URLSearchParams({ path: objectPath })
  return `${ASSET_ENDPOINT}?${params.toString()}`
}
